import { Meilisearch } from "meilisearch";
import Logger from "@cappelendamm/logger";

if (
  !process.env.NEXT_PUBLIC_MEILISEARCH_URL ||
  !process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY
) {
  Logger.error("One or more MeiliSearch environment variables are not defined");
}

const host = process.env.NEXT_PUBLIC_MEILISEARCH_URL ?? "";

export const searchClient = new Meilisearch({
  host,
  apiKey: process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY,
});
